<template>
  <div class="chart-description">
    <div class="primary">{{t(descriptionKey).text_chart_legend || t(indicator.id)}}</div>
    <div class="filterValue" v-if="textFilterContent">{{textFilterContent}}</div>
    <div class="secondary">{{t(descriptionKey).text_short}}</div>
    <div class="info-button" v-tooltip="{content: tooltipContent, trigger:'manual', show:tooltipOpen }" @click="tooltipOpen=!tooltipOpen"></div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
export default {
  name: "ChartDescription",
  props: ['indicator', 'descriptionKey', 'values'],
  mounted(){
    EventBus.$on('scroll',()=>{
      this.tooltipOpen=false
    })
  },
  data () {
    return {
      tooltipOpen: false
    }
  },
  computed: {
    tooltipContent () {
      return `<div class='tooltip-title'>${this.t(this.indicator.id)}</div><div class='tooltip-content'>${this.t(this.descriptionKey).text_tooltip}</div>`
    },
    textFilterContent () {
      if('nationality' in this.values){
        return this.t('nationality') + ': ' + this.t(this.values.nationality || 'all')
      } else if('sector_ticket' in this.values){
        return this.t('sector_ticket') + ': ' + this.t(this.values.sector_ticket || 'all')
      }
      else if('sector_recovery' in this.values){
        return this.t('sector_recovery') + ': ' + this.t(this.values.sector_recovery || 'all')
      }
    }
  }
}
</script>
<style lang="stylus">
  .tooltip
    max-width vw(300px)
    .tooltip-title
      m-font-size(18,22)
      margin-bottom vh(6px)
      font-family 'Georgia'

</style>
<style scoped lang="stylus">
  .chart-description
    align-content center
    text-align center
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .mobile &
      flex: 1 1 auto;
    .desktop &
      // margin vw(40px)
      flex: 1 1 auto;
    
    .primary
      m-font-size(18,28)
    .filterValue
      m-font-size(15,28)
      font-family 'Lato'
      font-weight $fw-bold
    .secondary
      font-family 'Lato'
      m-font-size(11,18)
      margin 0 vw(40px)
    .info-button
      cursor pointer
      margin 0 auto
      background-image url('~@/assets/icons/info_blue.svg')
      background-size contain
      background-repeat: no-repeat;
      background-position: center center;
      height vw(15px)
      width vw(15px)
      margin-top vh(6px)
</style>